import { useMemo, useCallback } from "react";
import Select from "components/ui/Select";
import { useItemsGroupedForSelect } from "http-hooks/agitem/useAgitem";

const ItemSelectSizeGrouped = ({ 
  value = null, 
  onChange, 
  vendorId = null, 
  placeholder = "Choose an item...",
  isClearable = true,
  isDisabled = false,
  className = "",
  isSearchable = true,
  requireVendor = true,
  label,
  ...props 
}) => {
  const { data: itemsData = [], isLoading, error } = useItemsGroupedForSelect(
    { vendorId },
    {
      enabled: requireVendor ? Boolean(vendorId) : true,
    }
  );

  const options = useMemo(() => {
    return itemsData.map(item => ({
      value: item.value,
      label: item.label,
      itemuom: item.itemuom,
      itmbasicuom: item.itmbasicuom,
      conval: item.conval,
      itmhsnId: item.itmhsnId
    }));
  }, [itemsData]);

  const handleSelectionChange = useCallback((selectedOption) => {
    if (onChange) {
      onChange(selectedOption);
    }
  }, [onChange]);

  if (error) {
    return (
      <div className="text-red-500 text-sm p-2 border border-red-300 rounded">
        Error loading items: {error.message}
      </div>
    );
  }

  const shouldDisable = isDisabled || (requireVendor && !vendorId);

  return (
    <Select
      {...props}
      label={label}
      value={value}
      options={options}
      onChange={handleSelectionChange}
      placeholder={requireVendor && !vendorId ? "Select vendor first..." : placeholder}
      isClearable={isClearable}
      isDisabled={shouldDisable}
      isLoading={isLoading}
      isSearchable={isSearchable}
      className={className}
      noOptionsMessage={() =>
        requireVendor && !vendorId
          ? "Please select a vendor first..."
          : isLoading
          ? "Loading items..."
          : "No items found"
      }
    />
  );
};

export default ItemSelectSizeGrouped;
